(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["up-social-proof"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('usp-reviews')) {
    class UspReviews extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('[data-usp-dialog]');
        this.body = this.querySelector('[data-usp-dialog-body]');
        this.handleClick = this.handleClick.bind(this);
        this.handleKey = this.handleKey.bind(this);
        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKey);

        if (this.dialog) {
          this.dialog.addEventListener('click', (event) => {
            if (event.target === this.dialog) this.dialog.close();
          });
          this.dialog.addEventListener('close', () => {
            this.body.replaceChildren();
            document.documentElement.classList.remove('usp-lock');
            this.classList.remove('is-modal-open');
            if (this.lastFocus) this.lastFocus.focus({ preventScroll: true });
          });
        }

        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.classList.toggle('is-visible', entry.isIntersecting);
                if (entry.isIntersecting) this.classList.add('is-seen');
              });
            },
            { rootMargin: '0px 0px -12% 0px' }
          );
          this.observer.observe(this);
        } else {
          this.classList.add('is-visible', 'is-seen');
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKey);
      }

      handleKey(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const card = event.target.closest('.usp-card');
        if (card && event.target === card) {
          event.preventDefault();
          this.open(card.dataset.uspOpen, card);
        }
      }

      handleClick(event) {
        const top = event.target.closest('[data-usp-top]');
        if (top) {
          event.preventDefault();
          if (this.dialog && this.dialog.open) this.dialog.close();
          const target =
            document.querySelector('.product-information, product-information, [id^="ProductInformation"], main');
          const y = target ? target.getBoundingClientRect().top + window.scrollY - 80 : 0;
          window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
          return;
        }

        if (event.target.closest('[data-usp-close]')) {
          this.dialog.close();
          return;
        }

        const arrow = event.target.closest('[data-usp-scroll]');
        if (arrow) {
          const track = this.querySelector('[data-usp-track]');
          if (track) {
            const dir = Number(arrow.dataset.uspScroll) || 1;
            track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
          }
          return;
        }

        if (event.target.closest('a') && !event.target.closest('[data-usp-open]')) return;
        const opener = event.target.closest('[data-usp-open]');
        if (opener) this.open(opener.dataset.uspOpen, opener);
      }

      open(index, opener) {
        if (!this.dialog || index === undefined) return;
        const tpl = this.querySelector(`template[data-usp-tpl="${index}"]`);
        if (!tpl) return;
        this.lastFocus = opener;
        this.body.replaceChildren(tpl.content.cloneNode(true));
        document.documentElement.classList.add('usp-lock');
        this.classList.add('is-modal-open');
        this.dialog.showModal();
        const video = this.body.querySelector('video');
        if (video) {
          video.muted = true;
          video.play().catch(() => {});
        }
      }
    }
    customElements.define('usp-reviews', UspReviews);
  }

  } catch(e) { console.error(e); }
})();
})();
